export function getRequest(): RequestInit {
    return {
        method: 'GET',
    };
}
